var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_core.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_core.js
// module chunks = 168707334958949